export const API_REPORTS_COUNTS_INDEX = 'API_REPORTS_COUNTS_INDEX'
export const API_REPORTS_COUNTS_SET_ALL_FILTERS = 'API_REPORTS_COUNTS_SET_ALL_FILTERS'

export const setAllFilters = (filters: any) => ({
  type: API_REPORTS_COUNTS_SET_ALL_FILTERS,
  ...filters,
})
